import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecoveryFormComponent } from './recovery-form.component';
import {DxButtonModule, DxLoadPanelModule, DxTextBoxModule, DxValidationGroupModule, DxValidatorModule} from 'devextreme-angular';
import {RouterModule} from '@angular/router';



@NgModule({
  declarations: [RecoveryFormComponent],
  imports: [
    CommonModule,
    DxValidationGroupModule,
    DxTextBoxModule,
    DxValidatorModule,
    DxButtonModule,
    DxLoadPanelModule,
    RouterModule
  ],
  exports: [RecoveryFormComponent]
})
export class RecoveryFormModule { }
